export const bottomPaddingCollapsed = 160; // 10rem
export const bottomPaddingExpanded = 48; // 3rem
export const roundingBuffer = 2; // 2px
